import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmCloseAccPopupComponent } from '../confirm-close-acc-popup/confirm-close-acc-popup.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-kb-close-my-accpopup',
  templateUrl: './kb-close-my-accpopup.component.html',
  styleUrls: ['./kb-close-my-accpopup.component.scss'],
  standalone: false
})
export class KbCloseMyAccpopupComponent {
  sub = new Subscription();
  isMobile: boolean = false;
  constructor(private breakpointObserver: BreakpointObserver,
    private matDialog: MatDialog) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }
  openDialog() {
    this.matDialog.open(ConfirmCloseAccPopupComponent, { maxWidth: '500px' });
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
